import { z } from "zod/v4";

/**
 * authoring schema / internal `VizSpec` / runtime component schema の離散語彙を
 * 一箇所に寄せ、層をまたいだ drift を防ぐ。
 */
export const VIZ_SORT_OPTIONS = ["desc", "asc", "none"] as const;
export const VIZ_STACKING_OPTIONS = ["grouped", "stacked"] as const;

export const vizSortSchema = z.enum(VIZ_SORT_OPTIONS);
export const vizStackingSchema = z.enum(VIZ_STACKING_OPTIONS);
export const vizSeriesToggleModeSchema = z.enum([
  "single-metric",
  "multi-metric",
]);
export const vizTimeSeriesYAxisModeSchema = z.enum([
  "auto",
  "single",
  "dual",
  "normalized",
]);
export const vizBarComparisonYAxisModeSchema = z.enum([
  "auto",
  "single",
  "dual",
]);
export const vizAxisSideSchema = z.enum(["left", "right"]);
